'use strict';

import 'lightgallery.js';
import 'lg-video.js';

const imageGrid = (function() {
  // Lightgallery (https://sachinchoolur.github.io/lightgallery.js/)
  // prettier-ignore
  const lightGalleryConfig = {
    counter: false,
    getCaptionFromTitleOrAlt: false,
    download: false,
    selector: '.js-lightgallery-item',
    width: '100vw',
    height: '100vh',
    autoplayFirstVideo: false,
    addClass: 'fixed-size',
    nextHtml: '<svg class="icon icon-arrow-pagination" aria-hidden="true" focusable="false"><use xlink:href="#icon-arrow-pagination"></use></svg><span class="sr-only">Next slide</span>',
    prevHtml: '<svg class="icon icon-arrow-pagination icon-arrow-pagination--rotate" aria-hidden="true" focusable="false"><use xlink:href="#icon-arrow-pagination"></use></svg><span class="sr-only">Previous slide</span>',
  };
  const galleries = Array.from(document.querySelectorAll('.js-lightgallery'));
  function init() {
    galleries.forEach(gallery => {
      lightGallery(gallery, lightGalleryConfig);
    });
  }
  return {
    init,
  };
})();

export default imageGrid;
